import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import React, { CSSProperties } from 'react';

import useStyles from './CategoryCard.style';

interface CategoryCardProps {
  category?: Partial<guesthouse.Category>;
  style?: CSSProperties;
  className?: string;
  onClick?: (category: Partial<guesthouse.Category>) => void;
  href?: string;
}

const CategoryCard: React.FC<CategoryCardProps> = (props) => {
  const { category, style, className, onClick, href } = props;
  const { classes, cx } = useStyles();

  const styleObj: CSSProperties = { ...style };

  if (typeof props.onClick === 'function') {
    styleObj.cursor = 'pointer';
  }
  
  return (
    (
      <Link
        href={href}
        style={{ display: 'block', width: '100%' }}
      >

        <Paper
          className={cx(classes.categoryPaper, className)}
          style={styleObj}
          onClick={() => typeof onClick === 'function' && onClick(category)}
        >
          {category.image && (
          <img
            src={category?.image}
            className={classes.categoryImage}
            alt={category.title}
          />
          )}

          <Typography className={classes.categoryLabel}>
            {category.title}
          </Typography>
        </Paper>

      </Link>
    )
  );
};

CategoryCard.defaultProps = {
  onClick: null,
  category: {},
  style: {},
  className: null,
};

export default CategoryCard;
